import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';

import { receiveProducts } from '@ttstr/actions';
import { Container, LoadingSpinner, Masonry, useIntl, ContentrArea } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';

const ProductListing: React.FC = () => {
  const { t } = useTranslation();
  const { loading, products } = useShallowEqualSelector(mapStateToProps);
  const { receiveProducts } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveProducts();
  }, [language]);

  return (
    <article>
      <Helmet>
        <title>{t(`PRODUCTS.TITLE`)}</title>
        <body className="product-listing-page" />
        <script>{`fbq("track", "ViewContent", {"content_category": "Product Listing"});`}</script>
      </Helmet>
      {new Date() < new Date('2022-10-07T23:59:59+0200') && (
        <div id="banner" className="py-3 text-center shadow container-fluid">
          <strong>{'Versandkostenfrei ab 65€ bis zum 07.10.22'}</strong>
        </div>
      )}

      <Container className="list-page">
        <div className="text-center">
          {/* <img src={require('./assets/images/logo.svg')} alt="Fortuna Ehrenfeld Logo" className="my-3 img-fluid w-50" /> */}
        </div>
        <Container className="pt-3">
          <ContentrArea id="before-listing" />
        </Container>

        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
        ) : products.length === 0 ? ( // if no products
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show products
          <Masonry
            id="product-listing"
            products={products}
            // filters={['fulltext', 'categoryId']}
            showSubtitle
            showFormerPrice
          />
        )}
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { products, loading } = state.Products;
  return {
    products,
    loading,
  };
};

const mapDispatchToProps = {
  receiveProducts,
};

export default React.memo(ProductListing);
